export const environment = {
  production: false,
  baseUrl: "https://api.qa.lenglishcommunity.com/api"
};